import React, { Component } from 'react'
import { Container } from 'react-bootstrap';


// components
import SubInput from './SubInput';


export default class Left extends Component {

    static displayName = Left.name;


    render() {
 
        return (
            
            <Container>

                <p style={{ padding: '30px', paddingLeft: '20px', paddingTop: '100px', fontSize: '40px' }}>
                    Smile is a <font color="#156fa1">mobile payment</font> and <font color="#156fa1">marketplace</font> app for Africa
                </p>

                <p style={{ padding: '20px', paddingBottom: '0px', fontSize: '20px', color: 'grey' }}>
                    Subscribe to stay updated on Smile's progress!
                </p>

                <p style={{  }}>
                    <SubInput />
                </p>

                

            </Container>

        );
 
    }

    
}

